import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=57e0bbb0&scoped=true"
import script from "./AppTable.vue?vue&type=script&lang=js"
export * from "./AppTable.vue?vue&type=script&lang=js"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=57e0bbb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e0bbb0",
  null
  
)

export default component.exports